const DEFAULT_EXPAND_OPTIONS = {
	allowInsertion: true,
	allowInteractiveExpand: true,
};

export const useExpandOptions = (): {
	allowInsertion: boolean;
	allowInteractiveExpand: boolean;
} => {
	return DEFAULT_EXPAND_OPTIONS;
};
